import styles from './table_view.module.css';

export type TableAlign = 'start' | 'center' | 'end';

export const alignStyles: Record<TableAlign, string> = {
  start: styles.align_start,
  center: styles.align_center,
  end: styles.align_end,
};
